<template>
  <div class="player">
    <div>
      <van-button
        :disabled="canPlay"
        size="small"
        style="margin-right: 5px"
        @click="playamr"
      >
        {{ playOrpause }}
      </van-button>
      <van-button :disabled="canPlay" size="small" @click="stopamr">
        停止
      </van-button>
    </div>
    <div class="time">
      <span>{{ min }}</span>
      /
      <span>{{ max }}</span>
    </div>
  </div>
</template>
<script>
  let BenzAMRRecorder = require('benz-amr-recorder')
  export default {
    props: {
      url: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        amr: null,
        playOrpause: '播放',
        canPlay: true,
        min: "0.00'",
        max: 0,
        useSetinterval: null,
      }
    },
    watch: {
      min: {
        handler(val) {
          if (val == "0.00'") {
            this.playOrpause = '播放'
          }
        },
      },
    },
    mounted() {
      this.amr = new BenzAMRRecorder()
      this.amr.initWithUrl(this.url).then(() => {
        this.canPlay = false
        this.max = this.amr.getDuration().toFixed(2) + "'"
      })
    },
    beforeUnmount() {
      if (this.useSetinterval) {
        clearInterval(this.useSetinterval)
      }
      if (this.amr.isPlaying()) {
        this.amr.stop()
      }
    },
    methods: {
      playamr() {
        if (this.amr.isPlaying()) {
          clearInterval(this.useSetinterval)
          this.playOrpause = '播放'
        } else {
          this.useSetinterval = setInterval(() => {
            this.min = this.amr.getCurrentPosition().toFixed(2) + "'"
          })
          this.playOrpause = '暂停'
        }
        this.amr.playOrPauseOrResume()
      },
      stopamr() {
        this.playOrpause = '播放'
        this.amr.stop()
        this.min = "0.00'"
        clearInterval(this.useSetinterval)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .player {
    width: 300px;
    height: 54px;
    border-radius: 100px;
    background: #f1f1f1;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    // justify-content: space-around;
  }
  .time {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
</style>
